import Button from '@components/legacy/core/Button';
import { useTranslations } from '../../context/TranslationContext';
import './index.less';

const EvaluationMainActions = ({ onAutofillClick, onAddClick }) => {
    const { t } = useTranslations();
    return (
        <div className='evaluation-main-actions'>
            {typeof onAutofillClick === 'function' && (
                <>
                    <Button className='autofill-evaluation-for-all-steps-button' type='default' onClick={(e) => {
                        e.preventDefault();
                        onAutofillClick();
                    }}>
                        {t('Add all requirements to all steps')}
                    </Button>
                    <div>{t('or')}</div>
                </>
            )}
            <Button
                isLink
                className='add-evaluation-step-btn'
                type='dashed-border'
                title={t('Add evaluation step')}
                icon='icon-svg-plus'
                onClick={e => {
                    e.preventDefault();
                    onAddClick();
                }}
            />
        </div>
    );
};

export default EvaluationMainActions;
